import {Tag} from 'folder-items/FileConstants';
import * as net from 'util/Net';

export async function addPrimersToField(
  sequenceId: string,
  data: {schemaFieldId: string; oligoIds: Array<string>}
): Promise<{tags: Array<Tag>}> {
  return await net.postJSONPromise({
    url: `/1/api/sequences/${sequenceId}/add-oligos-to-field`,
    data,
  });
}
